import apiClient from '../index';

export const getAuditReports = async (auditId: string) => {
	const response = await apiClient.get(`/audits/${auditId}/reports`);
	return response.data;
};

export const getAuditCoverage = async (auditId: string) => {
	const response = await apiClient.get(`/audits/${auditId}/coverage`);
	return response.data;
};

export const generateReport = async (auditId: string) => {
	const response = await apiClient.post(`/audits/${auditId}/reports`);
	return response.data;
};

export const setReportStatus = async (
	reportId: string,
	status: string,
	overrideReason: string,
) => {
	const response = await apiClient.patch(`/reports/${reportId}/status`, {
		status,
		overrideReason,
	});
	return response.data;
};
